import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('@/lang', true, /[a-z0-9]+\.json$/i)

  const messages = {}
  locales.keys().forEach((key) => {
    const matched = key.match(/([a-z0-9]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

export default new VueI18n({
  locale: Cookies.get('lang') || process.env.VUE_APP_LOCALE || navigator.language.substr(0, 2),
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
})
